'use client'

import { useEffect, useState } from 'react'
import { I18nextProvider } from 'react-i18next'
import i18n, { setLanguage } from '@/lib/i18n'
import { useThemeStore } from '@/lib/stores/theme-store'

interface I18nProviderProps {
  children: React.ReactNode
}

export function I18nProvider({ children }: I18nProviderProps) {
  const [isInitialized, setIsInitialized] = useState(false)
  const currentTheme = useThemeStore((state) => state.currentTheme)

  useEffect(() => {
    // Wait for i18n to be fully initialized
    if (i18n.isInitialized) {
      setIsInitialized(true)
    } else {
      i18n.on('initialized', () => {
        setIsInitialized(true)
      })
    }

    return () => {
      i18n.off('initialized')
    }
  }, [])

  // Update language when theme changes and provides a language
  useEffect(() => {
    if (currentTheme?.language && i18n.isInitialized) {
      // Only change if theme language is different from current
      if (currentTheme.language !== i18n.language) {
        console.log(`🌐 [i18n] Setting language from theme: ${currentTheme.language}`)
        setLanguage(currentTheme.language)
      }
    }
  }, [currentTheme?.language])

  // Render children without provider initially to avoid hydration issues
  // Once initialized on client, wrap with provider
  if (!isInitialized && typeof window === 'undefined') {
    return <>{children}</>
  }

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
}

